/**
 * Utility function to get a random selection of items from a given array
 * @param array Array of items
 * @param sampleSize Sample size
 * @returns A random selection of items from the given array of the requested sample size
 */
export const sample = <T>(array: T[], sampleSize = 1): T[] => {
  if (sampleSize < 1) {
    throw new Error('Sample size cannot be less than 1');
  }

  if (array.length === 1) {
    return array;
  }

  let size = sampleSize;

  if (sampleSize > array.length) {
    size = array.length;
  }

  const shuffled = Array.from(array).sort(() => 0.5 - Math.random());
  return shuffled.slice(0, size);
};
